import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Toolbar } from '@material-ui/core';

import { Icon } from '@hydra/common/components';
import { sendEvent } from '@hydra/utils/gtm';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles({ root: { justifyContent: 'flex-end' } });

interface CreateHeaderProps {
  href?: string
}

export const CreateHeader: React.FC<CreateHeaderProps> = ({ href: hrefProp }) => {
  const classes = useStyles();
  const { locale } = useI18n();
  const href = hrefProp || `/${locale}/overview`;
  return (
    <Toolbar className={classes.root}>
      <IconButton
        edge='start'
        color='inherit'
        aria-label='close'
        href={href}
        onClick={() => sendEvent('cflow-back-btn')}
      >
        <Icon type='cross' />
      </IconButton>
    </Toolbar>
  );
};

export default CreateHeader;
